<template>
  <div class="background-container py-4">
    <div class="quota-limit-container">
      <!-- column left -->
      <div class="quota-limit-message">
        <font-awesome-icon icon="lock" class="icon__lock" />
        <div class="text__limit-quota">
          <p ref="text__verify-quota-topic" class="font-weight-bold text-light">
            You have reached submission quota limit
          </p>
          <button
            type="button"
            variant="link"
            class="btn btn-link button__redeem-code"
            @click="onClickRedeemCode()"
          >
            Have a redeem code?
          </button>
        </div>
      </div>

      <!-- column right -->
      <div class="quota-purchase-options">
        <!-- left card -->

        <b-card class="card-box h-100">
          <div class="card-box__content">
            <div class="card-box__text">
              <h5 ref="text__verify-quota-price" class="font-size-xl text-black">
                <price-displayer
                  :normal-price="learningUnit.price_verify"
                  :discount-price="learningUnit.price_verify_discount"
                />
              </h5>

              <p ref="text__verify-quota-description" class="m-0 text-black-50">
                Get&nbsp;<span class="font-weight-bold text-black">+2</span>&nbsp;quotas to verify
              </p>
            </div>

            <b-button
              ref="button__verify-buy-now"
              disable-event-track
              class="btn button__buy-now btn-auto-width"
              href="javascript:void(0);"
              variant="primary"
              @click="onClickBuyButton($event, 'VERIFY')"
            >
              <span v-if="isApplied && mcIsAlreadyCart('VERIFY') && $_isFeatureEnabled('Cart')"
                >Go to cart
              </span>
              <span v-else-if="$_isFeatureEnabled('purchase_buynow')">Buy now</span>
              <span v-else>Enroll</span>
            </b-button>
            <b-button
              v-if="isApplied && !mcIsAlreadyCart('VERIFY') && $_isFeatureEnabled('Cart')"
              ref="button__verify-add-to-cart"
              :disabled="isAdding['VERIFY']"
              class="sml-2 px-3"
              :variant="'outline-primary'"
              disable-event-track
              @click="onClickButtonCart('VERIFY')"
            >
              <font-awesome-icon
                v-if="!isAdding['VERIFY']"
                icon="cart-shopping"
                class="icon__cart-shopping"
              />
              <b-spinner v-if="isAdding['VERIFY']" small />
            </b-button>
          </div>
        </b-card>

        <!-- right card -->
        <b-card class="card-box h-100">
          <!-- open applied learn and already applied -->
          <div
            v-if="
              isApplied && isApplied.mode == 'LEARN_VERIFY' && isApplied.remaining_submission == 0
            "
            class="card-box__content h-100"
          >
            <p class="card-box__text">Acquire abilities and skills to verify competency again.</p>

            <b-button
              ref="button__go-to-learning"
              class="btn button__go-to-learning btn-auto-width"
              href="javascript:void(0);"
              variant="warning"
              @click="goToLearningPage"
              >Go to learning</b-button
            >
          </div>

          <!-- open applied learn and not applied -->
          <div
            v-else-if="learningUnit.is_published && learningUnit.open_apply_learn"
            class="card-box__content"
          >
            <div class="card-box__text">
              <h5 ref="text__learn-quota-price" class="font-size-xl text-black">
                <price-displayer
                  :normal-price="learningUnit.price_verify_learn"
                  :discount-price="learningUnit.price_verify_learn_discount"
                />
              </h5>

              <p ref="text__learn-quota-description" class="m-0 text-black-50">
                Get&nbsp;<span class="font-weight-bold text-black">+2</span>&nbsp;quotas to verify
                and unlock access to online learning videos
              </p>
            </div>

            <b-button
              ref="button__buy-now-learn"
              disable-event-track
              class="btn button__buy-now-learn btn-auto-width"
              href="javascript:void(0);"
              :disabled="isApplied && isApplied.mode == 'LEARN_VERIFY' ? true : false"
              variant="warning"
              @click="onClickBuyButton($event, 'LEARN_VERIFY')"
            >
              <span
                v-if="isApplied && mcIsAlreadyCart('LEARN_VERIFY') && $_isFeatureEnabled('Cart')"
                >Go to cart
              </span>
              <span v-else-if="$_isFeatureEnabled('purchase_buynow')">Buy now</span>
              <span v-else>Enroll</span>
            </b-button>

            <b-button
              v-if="isApplied && !mcIsAlreadyCart('LEARN_VERIFY') && $_isFeatureEnabled('Cart')"
              ref="button__learn-add-to-cart"
              class="btn btn-lg ml-2 px-3"
              :variant="'outline-warning'"
              :disabled="isAdding['LEARN_VERIFY']"
              disable-event-track
              @click="onClickButtonCart('LEARN_VERIFY')"
            >
              <font-awesome-icon
                v-if="!isAdding['LEARN_VERIFY']"
                icon="cart-shopping"
                class="icon__cart-shopping"
              />
              <b-spinner v-if="isAdding['LEARN_VERIFY']" small />
            </b-button>
          </div>

          <!-- not open applied learn -->
          <div
            v-else
            class="card-box__content"
            :class="
              !interestFetching && userInterestedModeLearn !== null ? 'interest-confirmed' : ''
            "
          >
            <p class="card-box__text">Learning unit will be coming soon</p>

            <b-button
              ref="button__notify-me"
              disable-event-track
              class="btn button__notify-me btn-auto-width"
              :class="userInterestedModeLearn == null ? '' : 'px-2'"
              href="javascript:void(0);"
              :disabled="interestFetching || userInterestedModeLearn !== null"
              variant="warning"
              @click="submitInterest"
            >
              <b-spinner v-show="interestFetching" small class="mb-u1" />
              <span v-show="!interestFetching && userInterestedModeLearn == null">Notify me</span>
              <span
                v-show="!interestFetching && userInterestedModeLearn !== null"
                class="text__signed"
                >You’re signed for notification.</span
              >
            </b-button>
          </div>
        </b-card>
      </div>
    </div>

    <redeem-code-modal
      :show.sync="activeModalRedeem"
      :mc-id="learningUnit.id"
      :mode="actionMode"
      :success-alert-message="successAlertMessage"
      :redeem-type="'QUOTA'"
      @redeem:success="redeemSuccess"
    ></redeem-code-modal>

    <base-modal :show.sync="activeModalChangeMode" title="Change plan">
      <span>Do you want to change plan ?</span>
      <template v-slot:modal-footer>
        <b-button variant="link" @click="activeModalChangeMode = false">Cancel</b-button>
        <b-button ref="button__change-type" variant="success" @click="onChangeTypeMc">
          Confirm
        </b-button>
      </template>
    </base-modal>
  </div>
</template>

<script>
import LearningUnit from '@/models/LearningUnit';
import Application from '@/models/Application';
import { userInfoMixin } from '@/mixins/userInfoMixin';
import { notificationMixin } from '@/mixins/notificationMixin';
import RedeemCodeModal from '@/components/LearningUnit/RedeemCodeModal';
import PriceDisplayer from '@/views/LearningUnitExplore/components/PriceDisplayer';
import Section from '@/models/Section';
import Interest from '@/models/Interest';
import { amplitudeMixin } from '@/mixins/amplitudeMixin';
import Cart from '@/models/Cart';
import CartItem from '@/models/CartItem';
import { optimizelyMixin } from '@/mixins/optimizelyMixin';
import { throttle } from 'lodash';
import BaseModal from '@/components/base-components/BaseModal';
import LearningUnitOption from '@/models/LearningUnitOption';

export default {
  components: {
    RedeemCodeModal,
    PriceDisplayer,
    BaseModal
  },
  mixins: [userInfoMixin, notificationMixin, amplitudeMixin, optimizelyMixin],

  props: {
    learningUnit: {
      type: LearningUnit,
      required: true
    }
  },

  data() {
    return {
      activeModalRedeem: false,
      actionMode: null,
      applyFetching: false,
      successAlertMessage:
        'Access code is successfully verified, your submission quota has been updated.',
      interestFetching: false,
      interestModes: ['VERIFY', 'LEARN'],
      activeModalChangeMode: false,
      isAdding: { VERIFY: false, LEARN_VERIFY: false },
      mode: null
    };
  },

  computed: {
    isApplied() {
      return Application.query()
        .where((apply) => {
          return apply.user.id == this.userId && apply.learning_unit.id == this.learningUnit.id;
        })
        .first();
    },

    defaultSection() {
      return Section.query()
        .where('learning_unit_id', this.learningUnit.id)
        .where('is_default', true)
        .first();
    },

    userInterest() {
      return this.user
        ? Interest.query()
            .where('learning_unit_id', this.learningUnit.id)
            .where('user', this.userId)
            .where((record) => {
              return this.interestModes.includes(record.mode);
            })
            .get()
        : [];
    },

    userInterestedModeLearn() {
      return this.user
        ? Interest.query()
            .where('learning_unit_id', this.learningUnit.id)
            .where('user', this.userId)
            .where('mode', 'LEARN')
            .first()
        : null;
    },

    userCart() {
      return this.user ? Cart.query().where('user_id', this.user.id).first() : null;
    },

    quotaCartItem() {
      return this.userCart
        ? CartItem.query()
            .where('cart_id', this.userCart.id)
            .where('learning_unit_id', this.learningUnit.id)
            .with('learning_unit_option')
            .first()
        : null;
    },
    learningUnitOption() {
      return LearningUnitOption.query()
        .where('learning_unit_id', this.learningUnit.id)
        .where('option_type', 'QUOTA')
        .where('mode', this.mode)
        .first();
    }
  },

  async mounted() {
    // this.fetchCart();
    this.fetchApply();
    this.fetchInterest();
    this.onClickButtonCart = throttle(this.onClickButtonCart, 500);
    if (this.$route.query?.payload?.autoInterest) {
      await this.submitInterest();
    }

    if (this.$route.query.action === 'redeem') {
      this.activeModalRedeem = true;
    }
  },

  methods: {
    async fetchCart() {
      await CartItem.api().fetchMyCartItem();
    },
    formatPrice(number) {
      return Intl.NumberFormat('en-US', {
        currency: 'USD'
      }).format(number);
    },

    goToSignInPageWithRedirect() {
      const previousRoute = this.$router.resolve({
        ...this.$route,
        params: {
          learningUnitId: this.learningUnit.id
        }
      });

      this.$router.push({
        name: 'SignIn',
        query: {
          previousPath: previousRoute.href
        }
      });
    },

    activeModalVerify(event) {
      if (!this.userId) return this.goToSignInPageWithRedirect();
      this.actionMode = 'VERIFY';
      this.activeModalRedeem = true;
      this.$_amplitudeMixin_onClick(event.target, {
        Plan: this.actionMode
      });
      this.activeModalRedeem = true;
    },

    activeModalLearnVerify(event) {
      if (!this.userId) return this.goToSignInPageWithRedirect();
      this.actionMode = 'LEARN_VERIFY';
      this.activeModalRedeem = true;
      this.$_amplitudeMixin_onClick(event.target, {
        Plan: this.actionMode
      });
      this.activeModalRedeem = true;
    },

    goToLearningPage() {
      this.$router.push({
        name: 'learning-unit/feed',
        params: {
          learningUnitId: this.learningUnit.id,
          sectionId: this.defaultSection.id
        }
      });
    },

    async submitInterest(event = null) {
      let target = null;
      if (!event) {
        target = this.$refs['button__notify-me'];
      } else {
        target = event.target;
      }

      const { interestModes } = this;

      await this.$_amplitudeMixin_onClick(target, {
        InterestModes: interestModes
      });

      if (!this.userId) {
        return this.$router.push({
          name: 'SignIn',
          query: {
            previousPath: this.$route.path,
            payload: {
              autoInterest: true
            }
          }
        });
      }

      this.interestFetching = true;
      for (let index = 0; index < interestModes.length; index++) {
        const mode = interestModes[index];
        try {
          await Interest.api().createByLearner(this.learningUnit.id, mode);

          await this.$_amplitudeMixin_onCheck({
            InterestMode: mode
          });
        } catch (error) {
          if (error.response?.data?.message === 'this user already interest this learning unit') {
            console.log('this user already signed for interest: ', mode);
            await this.$_amplitudeMixin_onCheck({
              InterestMode: mode,
              Message: error.response.data.message
            });
            this.notiErrorDefault(error.response.data.messag);
          } else {
            console.log('create interest fail: ', error);
            await this.$_amplitudeMixin_onCheck({
              InterestMode: mode,
              Message: 'signign for interest fail.'
            });
            this.notiErrorDefault('Signign for interest fail.');
          }
        }
      }

      this.notiSuccessDefault('Your interest has been successfully recorded.');
      this.interestFetching = false;
    },

    async fetchApply() {
      if (!this.userId) return;

      try {
        this.applyFetching = true;
        await Application.api().find({
          user: this.userId,
          learning_unit: this.learningUnit.id
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.applyFetching = false;
      }
    },

    async fetchInterest() {
      this.interestFetching = true;
      if (!this.userId) {
        this.interestFetching = false;
        return;
      }

      try {
        await Interest.api().findOneByLearner(this.learningUnit.id);
      } catch (error) {
        console.log('error: ', error);
      }

      this.interestFetching = false;
    },

    redeemSuccess() {
      this.fetchApply();
    },

    // onClickButton(event, mode) {
    //   console.log(event, mode);

    //   if (!this.user) return this.goToSignInPageWithRedirect();

    //   if (this.quotaCartItem && this.$_isFeatureEnabled('Cart')) {
    //     //Go to cart
    //     this.$router.push({ name: 'cart-item' });
    //   } else if (this.$_isFeatureEnabled('Cart')) {
    //     //Buy now
    //   } else {
    //     //Enroll
    //     this.actionMode = mode;
    //     this.activeModalRedeem = true;
    //     this.$_amplitudeMixin_onClick(event.target, {
    //       Plan: this.actionMode
    //     });
    //   }
    // },

    onClickBuyButton(event, mode) {
      if (!this.userId) return this.goToSignInPageWithRedirect();

      this.mode = mode;
      let prop = {
        Plan: mode
      };

      if (this.$_isFeatureEnabled('purchase_buynow')) {
        //Buy now
        // Check if this is an upgrade: user has VERIFY and buying LEARN_VERIFY
        const isUpgrade =
          this.isApplied && this.isApplied.mode === 'VERIFY' && mode === 'LEARN_VERIFY';

        this.$router.push({
          name: 'checkout-option',
          params: {
            learningUnitOptionId: this.learningUnitOption.id
          },
          query: {
            previousPath: this.$route.fullPath,
            isUpgrade: isUpgrade ? 'true' : 'false'
          }
        });
      } else {
        //Enroll
        this.actionMode = mode;
        this.activeModalRedeem = true;
      }

      this.$_amplitudeMixin_onClick(event.target, prop);
    },

    async onClickButtonCart(mode) {
      if (!this.user) return this.goToSignInPageWithRedirect();
      this.isAdding[mode] = true;
      if (!this.quotaCartItem) {
        await Cart.api().addQuotaItem({
          learning_unit: this.learningUnit.id,
          mode: mode
        });

        this.$toast.success(`Quota added to cart successfully`);
        this.$emit('add-item:success');
      } else if (this.quotaCartItem && this.quotaCartItem.learning_unit_option.mode != mode) {
        //Change type
        this.activeModalChangeMode = true;
        this.isAdding[mode] = false;
      }
    },

    mcIsAlreadyCart(mode = '') {
      return (
        this.quotaCartItem !== null &&
        this.quotaCartItem.learning_unit_option.mode == mode &&
        this.quotaCartItem.learning_unit_option.option_type == 'QUOTA'
      );
    },
    async onChangeTypeMc() {
      if (!this.quotaCartItem) return;

      const { id } = this.quotaCartItem;

      let mode =
        this.quotaCartItem.learning_unit_option.mode == 'VERIFY' ? 'LEARN_VERIFY' : 'VERIFY';

      await CartItem.api().updateQuota(id, { mode });

      this.activeModalChangeMode = false;
      this.isAdding[mode] = false;
      this.$toast.success(`Your cart has been updated`);
    },

    onClickRedeemCode() {
      this.activeModalRedeem = true;
    },

    onCloseModalRedeem() {
      this.activeModalRedeem = false;
      this.fetchApply();
    }
  }
};
</script>
<style scoped lang="scss">
.background-container {
  width: 100%;
  background: linear-gradient(91.61deg, #667ce8 0%, #744ba3 100%);
  height: fit-content;
}

.quota-limit-container {
  display: grid;
  grid-template-columns: 1fr;
  gap: 30px;
  max-width: none;
  padding: 0 20px;
}

.quota-purchase-options {
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
}

.icon__lock {
  background: #e5f9ed;
  width: max-content;
  padding: 8px 10px;
  color: #1bc943;
  border-radius: 4px;
  margin-bottom: 0.5rem;
}

.card-box {
  min-height: 160px;
}

.card-box__content {
  height: 100%;
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  font-weight: 500;
  align-content: space-between;
}

.card-box__text {
  margin: 0;
  word-break: break-word;
  color: #07091980;
}

.text__description-quota {
  font-size: 16px;
}

.btn-auto-width {
  width: fit-content;
  height: fit-content;
}

.button__redeem-code {
  color: #fff;
  text-decoration: underline;
  padding: 0;
}

.text__limit-quota {
  color: #fff;
  font-size: 16px;
  line-height: 24px;
}

.interest-confirmed {
  display: flex;
  flex-wrap: wrap;
}

@media screen and (min-width: 576px) {
  .card-box {
    min-height: 0;
  }
  .quota-purchase-options {
    grid-template-columns: 1fr 1fr;
  }
}

@media screen and (min-width: 768px) {
  .container {
    padding: 0;
  }
  .card-box__content {
    grid-template-columns: 1fr max-content;
  }
  .btn-auto-width {
    justify-self: end;
  }
  // .quota-limit-container {
  //   grid-template-columns: 1fr 2fr;
  // }
}

@media screen and (min-width: 992px) {
  .quota-limit-container {
    max-width: 960px;
    margin: auto;
    grid-template-columns: 1fr 2fr;
  }
}
@media screen and (min-width: 1200px) {
  .quota-limit-container {
    max-width: 1140px;
  }
}
</style>
